<template>
  <div class="x-color-picker__wrapper">
    <div
      class="x-color-picker__trigger"
      :style="{
        backgroundColor: inputColor,
      }"
    ></div>
    <el-input
      v-model="inputColor"
      class="my-ipt"
      size="small"
    ></el-input>

    <el-button plain type="text" @click="confirmColor">确认</el-button>
  </div>
</template>

<script>
import baseMixin from './mixins'
export default {
  mixins: [baseMixin],
  data() {
    return {
      inputColor: '',
    }
  },
  watch: {
    'colorRoot.value': {
      immediate: true,
      handler: function(val, oldVal) {
        this.inputColor = val
      },
    },
  },
  methods: {
    checkColor(str) {
      return /^#([a-fA-F\d]{6}|[a-fA-F\d]{3})$/.test(str)
    },
    confirmColor() {
      if (this.checkColor(this.inputColor)) {
        this.__confirm(this.inputColor)
      } else {
        this.$message.info('请输入正确的颜色值')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.x-color-picker__wrapper {
  padding-top: 20px;
  display: flex;
  .x-color-picker__trigger {
    width: 30px;
    height: 30px;
    box-sizing: border-box;
    background-color: #000000;
    border: 1px solid #e6e6e6;
    border-radius: 4px;
    cursor: unset;
  }
  .my-ipt {
    margin: 0 4px;
  }
}
</style>
